import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {  Container } from '@mui/material';
import Carousel from 'react-material-ui-carousel';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function Hero() {

  const [promotions, setPromotions] = React.useState(
    [
      {
        title: 'Elevate your digital experience with software solution',
        isVideo:true,
        description:
          "Let's collaborate to create your systems that not only meets but surpasses your expectations. With us, your development is destined for the top charts. Our commitment to innovation, quality, and client satisfaction makes us the perfect partner for your system development needs.",
        image: "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fvideo%2Fliquid_leidenfrost.mp4?alt=media&token=52dd3d42-9528-4fc9-8ab2-d310b224ff34",
      },
    ]
  )

  React.useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <Container
      id="promotions"
      maxWidth={false}
      disableGutters
      component="main"
      sx={{ position: 'relative', zIndex: 1, height: '100vh' }}   // ✅ vh
    >
      <Carousel indicators={false} fullHeightHover animation="slide">
        {promotions.map((promo, index) => (
          <Box elevation={0} key={promo.title || index} sx={{ borderRadius: 0 }}>
            {promo.isVideo ? (
              <Box
                component="video"
                src={promo.image}
                sx={{ height: '100vh', objectFit: 'cover', width: '100%' }}   // ✅ vh
                controls={false}
                autoPlay
                muted 
                loop
              />
            ) : (
              <Box
                component="img"
                image={promo.image}
                alt={promo.title}
                sx={{ height: '100vh', objectFit: 'cover', width: '100%' }}   // ✅ vh
              />
            )}

            {/* Overlay content */}
            <Box
              sx={{
                background: "#d8d8d8",
                position: "absolute",
                top: "50%",
                left: { xs: "0%", md: "10%" }, // center on mobile, 10% on desktop
                transform: { xs: "translate(0%, -50%)", md: "translateY(-50%)" },
                color: "#000000ff",
                textAlign: { xs: "left", md: "left" }, // center text on mobile
                p: { xs: 3, sm: 4, md: 8 },           // smaller padding on small screens
                maxWidth: { xs: "100%", md: "60%" },    // almost full width on mobile
                borderRadius: 2,
              }}
            >
              <Stack spacing={1} data-aos="fade-right">
                <Typography variant="h4" md={{ variant: "h3" }} fontWeight="bold" gutterBottom>
                  {promo.title}
                </Typography>
                <Typography variant="body1" md={{ variant: "h6" }}>
                  {promo.description}
                </Typography>
              </Stack>
            </Box>
          </Box>
        ))}
      </Carousel>
    </Container>

  );
}